import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectPageType } from '../../selectors/page';
import { EPageType } from '../../types/page';
import { VacancyContainer } from '../Vacancy';
import { ListingContainer } from '../Listing';

export const PageContainer: React.FC = () => {
  const pageType = useSelector(selectPageType);

  switch (pageType) {
    case EPageType.Card:
      return <VacancyContainer />;
    case EPageType.Listing:
      return <ListingContainer />;
    default:
      return null;
  }
};

PageContainer.displayName = 'PageContainer';
